"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = void 0;
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const useFetch_1 = __importDefault(require("./SWR/useFetch"));
function useUser(url) {
    const [cookies] = react_cookie_1.useCookies(['last_logged_in_at']);
    const hasLoginCookie = !!cookies.last_logged_in_at;
    const [finishedAuth, setFinishedAuth] = react_1.useState(false);
    const [user, setUser, userFetcher] = useFetch_1.default({
        swrOptions: {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
        },
        isAllowed: hasLoginCookie,
        url,
    });
    react_1.useEffect(() => {
        if (!hasLoginCookie || user) {
            setFinishedAuth(true);
        }
    }, [hasLoginCookie, user]);
    let authed;
    if (userFetcher.status === 'loading') {
        authed = 'loading';
    }
    if (user) {
        authed = true;
    }
    return {
        finishedAuth,
        setFinishedAuth,
        user,
        setUser,
        userFetcher,
        authed,
    };
}
exports.useUser = useUser;
